module.exports = __webpack_public_path__ + "static/media/geschichte-team.223731f8.jpg";